module.exports = __webpack_public_path__ + "assets/img/right_item03.e7ab814f.png";